module.exports = {"TXTWCL_Today":{"id":"TXTWCL_Today","defaultMessage":"I dag"},"TXTWCL_Tomorrow":{"id":"TXTWCL_Tomorrow","defaultMessage":"I morgen"}}